import { graphql } from 'gql.tada';

export const GET_GENRES = graphql(`
    query GetGenres($contentType: ContentType!) {
        genres(contentType: $contentType) {
            id
            title
        }
    }
`);
